import React from 'react';
import PropTypes from 'prop-types';
import authHelper from 'helpers/auth';
import compose from 'recompose/compose';
import PhoneInput from 'components/form/InputFields/MobianPhoneInput/PhoneInput';
import RenderBooleanInputField from 'components/form/InputFields/RenderBooleanInputField';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubmitButton from 'components/button/SubmitButton';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { Field, reduxForm } from 'redux-form';

class CurrentAccountEditForm extends React.Component {
    componentDidMount() {
        const { data, initialize } = this.props;

        initialize(data);
    }

    render() {
        const {
            handleSubmit,
            handleSubmitForm,
            submitting,
            translate,
        } = this.props;

        const isOwner = authHelper.isOwner();

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <Section title={ translate('resources.accounts.forms.account') }>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    disabled={ !isOwner }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.name') }
                                    name='name'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.email') }
                                    name='email'
                                    validate={ validations.required }
                                />
                            </Item>

                            <Item>
                                <Field
                                    component={ PhoneInput }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.phone') }
                                    name='phone'
                                    source='phone'
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section title={ translate('resources.accounts.forms.address') }>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.address') }
                                    name='address'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.zipcode') }
                                    name='zipcode'
                                    validate={ validations.required }
                                />
                            </Item>

                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.city') }
                                    name='city'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.country') }
                                    name='country'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section title={ translate('resources.accounts.forms.registrations') }>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.vat') }
                                    name='vat'
                                />
                            </Item>

                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.iban') }
                                    name='iban'
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.bic') }
                                    name='bic'
                                />
                            </Item>

                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.accounts.fields.registration') }
                                    name='registration'
                                />
                            </Item>
                        </Row>
                    </Section>

                    { isOwner &&
                        <Section title={ translate('resources.accounts.forms.notifications') }>
                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderBooleanInputField }
                                        fullWidth={ false }
                                        label={ translate('resources.accounts.fields.notify_on_cancelled') }
                                        name='notify_on_cancelled'
                                    />
                                </Item>
                            </Row>
                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderBooleanInputField }
                                        fullWidth={ false }
                                        label={ translate('resources.accounts.fields.notify_on_created') }
                                        name='notify_on_created'
                                    />
                                </Item>
                            </Row>
                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderBooleanInputField }
                                        fullWidth={ false }
                                        label={ translate('resources.accounts.fields.notify_on_modified') }
                                        name='notify_on_modified'
                                    />
                                </Item>
                            </Row>
                        </Section>
                    }

                    <Section>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ submitting }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

CurrentAccountEditForm.propTypes = {
    data: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    translate,
    reduxForm(),
);

export default enhance(CurrentAccountEditForm);



// WEBPACK FOOTER //
// ./src/pages/accounts/current-account/edit/CurrentAccountEditForm.js